export default __webpack_public_path__ + "static/media/React.6fccafcb.jpg";